export function handleShowMoreClick({
  setShowLimit,
  _showLimit,
  showLimit,
  onShowMoreClick,
}) {
  if (_showLimit === "all") {
    setShowLimit(showLimit);
    typeof onShowMoreClick === "function" && onShowMoreClick(false);
  } else {
    setShowLimit("all");
    typeof onShowMoreClick === "function" && onShowMoreClick(true);
  }
}
